import { ReactNode, useLayoutEffect, useRef } from 'react';
import cx from 'classnames';

/** Keep each tab mounted and restore its scroll position after it becomes visible. */
export const EventDetailsTabPanel = ({
    tab,
    active,
    hasTabs = true,
    children,
}: {
    tab: 'details' | 'responses';
    active: boolean;
    hasTabs?: boolean;
    children: ReactNode;
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const scrollTop = useRef(0);
    useLayoutEffect(() => {
        if (active && ref.current) ref.current.scrollTop = scrollTop.current;
    }, [active]);
    return (
        <div
            ref={ref}
            id={`event-${tab}-panel`}
            role={hasTabs ? 'tabpanel' : undefined}
            aria-labelledby={hasTabs ? `event-${tab}-tab` : undefined}
            hidden={!active}
            tabIndex={hasTabs ? 0 : undefined}
            onScroll={event => {
                if (active) scrollTop.current = event.currentTarget.scrollTop;
            }}
            className={cx(
                'min-h-0 flex-1 flex-col overflow-y-auto [scrollbar-gutter:stable]',
                active ? 'flex' : 'hidden',
            )}
        >
            {children}
        </div>
    );
};
